
import React, { useState, useEffect } from 'react'
import Modal from 'components/modal'
import 'less/edit-survey-id-modal.less'
import { timezone } from 'shared/helpers/user'
import Storage from 'shared/helpers/storage'
import TimezoneSelect from 'components/timezone-select'


const ChangeTimeZoneModal = props => {
    const [selectedTimezone, setSelectedTimezone] = useState(props.userTimeZone)
    return (
        <Modal
            title={"CHANGE TIME ZONE"}
            isOpen={props.isOpen}
            className="change-timezone-modal"
            type="modal"
            autoFocusSubmit={false}
            submitBtnText="Save"
            onCancel={props.onClose}
            onSubmit={() => props.updateUserTimezone({ userId: props.userId, timezone: selectedTimezone })}
            isSubmitting={props.isSubmitting}
            enableSubmit={props.userTimeZone !==  selectedTimezone}
        >
            <div className="change-timezone-modal-body">
                <div className="change-timezone-modal-text">
                    <p> {props.t('update.timezone.message')} </p>
                    <div className='timezone-container'>
                        {props.t('timezone.title')}
                        <div className='timezone-select'>
                            <TimezoneSelect
                                searchable={false}
                                value={selectedTimezone}
                                placeholder={timezone[selectedTimezone]}
                                onChange={e => { setSelectedTimezone(e.value) }}
                                clearable={false}
                                userTimeZone={props.userTimeZone}                           
                            >
                            </TimezoneSelect>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ChangeTimeZoneModal
